import axios from "axios";

const abacusCoreApiBaseUrl =
  process.env.NODE_ENV === "production"
    ? "https://us-central1-abacuscorev2live.cloudfunctions.net/"
    : "https://us-central1-abacus-company-project.cloudfunctions.net/";
export const instance = axios.create({
  baseURL: abacusCoreApiBaseUrl,
  // 5 minutes
  timeout: 300000,
  headers: {
    "Access-Control-Allow-Origin": "*",
    "content-type": "application/json",
    Authorization: "ApiKey 75kY0sSlOILOlfLE6hQbFu57f2VA1JirTEy79Thy"
  }
});
